import { Tag } from 'antd';
// helpers
import dayjs from 'dayjs'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

const colors = {
  Cerrado: 'red',
  Closed: 'red',
  Close: 'red',
  Activo: 'green',
  Active: 'green'
}

const StatusCell: React.FC = (status: string, record) => {

  if (!status) return null

  const color = get(colors, status, 'red')

  const style = { display: 'flex', alignItems: 'center', justifyContent: 'start' }
  const props = {
    container: {
      style,
    }
  }

  return (
    <div {...props.container}>
      <div style={style}>
        <Tag color={color}>{status}</Tag>
      </div>
    </div>
  )
}

export default StatusCell
